<template>
  <div id="viewPoint" class="container">
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path:'/user/points'}">积分商城</el-breadcrumb-item>
        <el-breadcrumb-item>商品详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="box">
      <el-row :gutter="20">
        <el-col :span="10">
          <div>
            <img class="cover" :src="serve +  '/'+data.images">
          </div>
        </el-col>
        <el-col :span="14">
          <div>
            <div class="lv2Text t">{{data.title}}</div>
            <div class="box2">
              <div class="lv0Text t2">
                <span class="t3">{{data.integral}}</span>积分
              </div>
              <div class="lv3Text t4">
                <s>市场价：&yen;{{data.selling_price}}</s>
              </div>
              <div class="lv3Text">
                <span class="s">
                  <i class="fas fa-check-circle"></i> 服务承诺
                </span>
                <span class="s">
                  <i class="fas fa-check-circle"></i> 正品保证
                </span>
                <span class="s">
                  <i class="fas fa-check-circle"></i> 极速发货
                </span>
              </div>
            </div>
            <div class="box3">
              <el-button plain type="primary" style="width:150px;" @click="submit">立即兑换</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div style="margin-top:20px">
      <el-row :gutter="20">
        <el-col :span="18">
          <div class="box4">
            <div class="l1 lv2Text" style="margin-bottom:10px;">商品介绍</div>
            <div class="lv2Text" style="line-height:2em">
              <el-row>
                <el-col :span="12">
                  <div>
                    <span>商品名称：{{data.title}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    <span>商品规格：{{data.specification}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <span>货号：{{data.item_no}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    <span>产品分类：{{data.classification}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="lv2Text l2">详情：</div>
            <div class="lv2Text info" v-html="data.info"></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="box4 lv2Text" align="center">
            <div>
              看了还看
              <el-button type="text" style="margin-left:10px" @click="refresh">
                <i class="fas fa-undo"></i>换一批
              </el-button>
            </div>
            <div class="item" v-for="(item,index) of data2" :key="index">
              <div>
                <router-link :to="'/user/viewPoint?id='+item.inte_id">
                  <img class="cover2" :src="serve +item.images">
                </router-link>
              </div>
              <div style="padding:10px 0">
                <router-link :to="'/user/viewPoint?id='+item.inte_id">
                  {{
                  _.truncate(item.title, {
                  'length': 15,
                  })
                  }}
                </router-link>
              </div>
              <div>
                <span class="lv0Text">{{item.integral}}积分</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      //
      data: "",
      data2: ""
    };
  },
  created() {
    this.axios.get(this.serve + "/two_integral").then(res => {
      this.data2 = res.data.data;
    });
    this.initData();
  },
  methods: {
    //
    submit() {
      this.$router.push(
        "/user/createOrder1?id=" +
          this.$route.query.id +
          "&p=" +
          this.data.product_id
      );
    },
    refresh() {
      this.axios.get(this.serve + "/two_integral").then(res => {
        this.data2 = res.data.data;
      });
    },
    initData() {
      this.axios
        .get(this.serve + "/integral_detail", {
          params: {
            inte_id: this.$route.query.id
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
    }
  },
  watch: {
    $route: "initData"
  }
};
</script>
<style lang="scss">
#viewPoint {
  .item {
    margin-bottom: 20px;
  }
  .cover2 {
    width: 190px;
    height: 190px;
    display: block;
  }
  .l2 {
    font-weight: bold;
    margin-top: 20px;
  }
  .info {
    margin: 10px 0;
    line-height: 1.8em;
  }
  .l1 {
    font-size: 18px;
    text-align: center;
    padding: 10px 0;
  }
  padding-bottom: 40px;
  .box4 {
    padding: 20px 40px;
    background-color: #fff;
  }
  .s {
    margin-right: 15px;
  }
  .t4 {
    padding: 20px 0;
  }
  .t3 {
    font-size: 18px;
    font-weight: 800;
    margin-right: 5px;
  }
  .t2 {
    padding: 10px 0;
  }
  .cover {
    display: block;
    width: 100%;
  }
  .t {
    font-size: 20px;
    margin: 20px 0;
  }
  .box {
    background-color: #fff;
    padding: 20px 40px;
  }
  .box2 {
    background-color: #f2f2f2;
    padding: 30px;
  }
  .box3 {
    padding: 20px 0;
    border-top: 1px solid #ddd;
    margin-top: 20px;
  }
}
</style>